import { ReactElement } from "react";

export default function IconSQL(): ReactElement {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.13,7.41c.19-.3.15-.69-.1-.94l-3.54-3.53-.08-.06c-.3-.2-.69-.15-.94.1l-.1.12c-.19.3-.15.69.1.94l2.97,2.97-3,3-.06.08c-.2.3-.16.69.13.98l.08.06c.13.08.27.12.41.12.19,0,.39-.07.53-.22l3.53-3.54.06-.08Z"
        fill="#071722"
      />
      <path
        d="M13,12.25h-6c-.41,0-.75.34-.75.75s.34.75.75.75h6c.41,0,.75-.34.75-.75s-.34-.75-.75-.75Z"
        fill="#071722"
      />
    </svg>
  );
}
